import { inject, Injectable } from '@angular/core';

import { A11yFocusService } from './a11y-focus.service';

export type A11yToastType = 'success' | 'info' | 'warning' | 'error';

@Injectable({
  providedIn: 'root'
})
export class A11yToastService {
  private readonly a11yFocusService = inject(A11yFocusService);

  public applyToastA11y(
    toastElement: HTMLElement | null | undefined,
    type: A11yToastType,
    onHidden?: (callback: () => void) => void
  ): void {
    if (!toastElement) {
      return;
    }

    toastElement.setAttribute('role', type === 'error' ? 'alert' : 'status');
    toastElement.setAttribute('aria-atomic', 'true');

    if (type !== 'error') {
      return;
    }

    this.a11yFocusService.capturePreviousFocus();
    this.a11yFocusService.trapFocus(toastElement);

    requestAnimationFrame(() => {
      this.a11yFocusService.focusInitialElement(toastElement);
    });

    onHidden?.(() => {
      this.a11yFocusService.cleanup(toastElement);
      this.a11yFocusService.restoreFocus();
    });
  }
}
